import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalService } from '@obo-main/services/modal/modal.service';
import { Subject } from 'rxjs';
import { RestoreConfigurationService } from '@obo-main/services/configurator/restoreConfiguration.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-restore-configuration',
    templateUrl: './restoreConfiguration.component.html',
    standalone: false,
    styleUrls: ['./restoreConfiguration.component.scss']
})
export class RestoreConfigurationComponent implements OnInit, OnDestroy {
    @ViewChild('restoreConfigurationModal') modal: TemplateRef<any>;
    private destroy: Subject<void> = new Subject();

    constructor(
        private restoreConfigurationService: RestoreConfigurationService,
        private modalService: ModalService,
        private viewContainerRef: ViewContainerRef
    ) {}

    public ngOnInit(): void {
        this.restoreConfigurationService
            .onModalShow()
            .pipe(takeUntil(this.destroy))
            .subscribe(() => {
                this.open();
            });
    }

    public open(): void {
        this.modalService
            .open(this.modal, { viewContainerRef: this.viewContainerRef })
            .result.then(() => {
                this.restoreConfigurationService.setModalResult(true);
            })
            .catch(() => this.restoreConfigurationService.setModalResult(false));
    }

    public ngOnDestroy(): void {
        this.destroy.next();
        this.destroy.complete();
    }
}
